function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M158.858 27.918c-2.214.787-4.923 1.503-7.954 1.799a83.461 83.461 0 001.171-7.015c.121-.975-1.202-1.567-1.947-.928-2.149 1.843-5.743 4.253-10.442 4.983-1.954.304-4.067.523-6.241.738l-.36-.08c-13.566-2.97-28.439-6.229-37.085 2.09-1.626 1.564-2.987 3.31-4.127 5.14C77.311 37.366 70 48.476 70 64.444V81.67c0 1.019.024 2.031.072 3.037a7.236 7.236 0 015.127.912C76.272 74.297 80.156 64.095 86 56.224v.276s37.773 17.395 59.306-1.326c6.215 7.836 10.433 18.17 11.734 29.706 1.526-.565 4.152-.62 5.877-.047.055-1.047.083-2.102.083-3.163V64.443c0-9.034-2.58-16.514-7.494-21.799 2.639-4.111 4.897-8.26 6.548-11.5.906-1.778-1.315-3.895-3.196-3.226z",
  fill: "#2161AA"
});

function SvgHair87(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/hair-8-7.873d8855.svg";
export { SvgHair87 as ReactComponent };